module.exports = __webpack_public_path__ + "img/accounting-business-tax.4b162984.svg";